import CityPageTemplate from "../city-template/CityPageTemplate";
import { gardnervilleConfig } from "./data";

export default function GardnervillePage() {
  return <CityPageTemplate config={gardnervilleConfig} />;
}